import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import NextImage from '@/components/NextImage';

export default function A() {
    const { useLang } = useGlobal();
    const { t } = useLang('save_electric');

    return (
        <div className={`save-electric-a ${css.SaveElectricA}`}>
            <section className="section-a">
                <NextImage
                    webpSrc={require('@publicLocal/save-electric/pc/kv.webp')}
                    src={require('@publicLocal/save-electric/pc/kv.jpg')}
                    alt={t('sec_1_title')}
                    aria-label={t('sec_1_title')}
                />
                <div className="text-wrapper">
                    <h1 className="title white">{t('sec_1_title')}</h1>
                    <p className="desc white">{t('sec_1_desc')}</p>
                </div>
            </section>
        </div>
    );
}
